"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@mui/material/styles");
var _CTextField = _interopRequireDefault(require("./CTextField"));
const _excluded = ["className", "children", "error"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const StyledDisplayField = (0, _styles.styled)(_CTextField.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    paddingBottom: theme.spacing(1),
    '& .MuiInputBase-input': {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      color: theme.palette.primary.contrastText,
      cursor: 'default'
    },
    '& .MuiInputBase-root.Mui-error': {
      backgroundColor: (0, _styles.alpha)(theme.palette.error.main, 0.16),
      borderRadius: 4
    },
    '& .MuiInput-underline.Mui-error:after': {
      borderBottom: "2px solid ".concat(theme.palette.error.main),
      transform: 'none',
      transition: 'none'
    },
    '& .MuiInput-underline:not(.Mui-error):after': {
      borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
      transform: 'none',
      transition: 'none'
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: '1px solid rgba(0, 0, 0, 0.42)'
    }
  };
});

/**
 * アンダーラインのある文字列表示部品(CTextField拡張).
 *
 * @prop {string} children - 表示文字列
 * @prop {boolean} [error] - エラー表示（下線赤＋薄赤背景）
 */
const DisplayField = props => {
  const {
      className,
      children,
      error
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(StyledDisplayField, _extends({
    variant: "standard",
    className: className,
    inputProps: {
      readOnly: true
    },
    value: children,
    error: !!error
  }, rest, {
    onChange: () => {}
  }));
};
DisplayField.propTypes = {
  children: _propTypes.default.string.isRequired,
  error: _propTypes.default.bool
};
var _default = exports.default = DisplayField;